import { useTriviaContext } from "../context-trivia";
import { formatTriviaScore } from "../trivia-score";
import { TriviaResultChart } from "./TriviaResultChart";
import { TriviaResultQrCode } from "./TriviaResultQrCode";

export function TriviaResult() {
  const { config, score } = useTriviaContext();
  const scoreText = formatTriviaScore(score, config.results.scoreFormat);

  return (
    <div className="flex h-full min-h-0 w-full flex-col items-center justify-center gap-[var(--trivia-space)] overflow-x-hidden overflow-y-auto overscroll-contain px-[var(--trivia-space)]">
      <div
        className="hyphens-auto text-balance break-words text-center font-bold"
        style={{ fontSize: "var(--trivia-text-display)" }}
      >
        {config.results.heading}
      </div>
      {config.results.showChart ? (
        <div className="min-h-0 w-full flex-1">
          <TriviaResultChart />
        </div>
      ) : (
        !!scoreText && (
          <div
            className="font-bold"
            style={{ fontSize: "var(--trivia-text-body)" }}
          >
            {scoreText}
          </div>
        )
      )}
      {!!config.results.message && (
        <div
          className="text-balance break-words text-center"
          style={{
            fontSize: "var(--trivia-text-body)",
            color: config.theme.secondaryTextColor,
          }}
        >
          {config.results.message}
        </div>
      )}
      <TriviaResultQrCode />
    </div>
  );
}
